import React, { useEffect } from "react";
import { MenuCategory, appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { useStyles } from "./useStyles";
import { MenuItemCard } from "../MenuItemCard";
import { Subtitle2 } from "@fluentui/react-components";

interface MenuCategoryProps {
  category: MenuCategory;
}

export const MenuCategoryCard = ({ category }: MenuCategoryProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "MenuCategoryCard",
      category: category.name,
    });
  }, [appInsights, context, category.name]);

  return (
    <div className={styles.container} data-testid="menuCategoryCard">
      <Subtitle2 className={styles.categoryHeader}>{category.name}</Subtitle2>
      <div className={styles.menuItemsContainer}>
        {category?.items?.map((item) => {
          return (
            <div className={styles.menuItemContainer} key={item.id}>
              <MenuItemCard key={item.id} menuItem={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
